import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Cell, DataBlock, Grid } from '@fs/zion-ui'
import { PersonLink, TreePersonLink, UserLink } from '../../../app/Links'
import { isNullOrUndefined } from '../../../../util/Utils'
import { LabelsBlock } from '../../commonComponents/CommonComponents'
import { TreeIdCells } from './TreeIdBlock'

export default () => {}

export function ReservationHeldByNonContributorMessageSummary({
  messageDetails,
  queueCachesState,
  queueCachesActions,
}) {
  const { t } = useTranslation()
  const personId = messageDetails?.personId
  const contributorsIds = messageDetails?.contributorIdsOfReservationHolders?.split(' ') || []
  const personSummary = queueCachesState.personsCache[personId]
  const personLabels = queueCachesState.labelsCache[personId]

  useEffect(() => {
    queueCachesActions.fetchPersonSummary(personId)
    contributorsIds.forEach((contributorId) => {
      queueCachesActions.fetchUserSummary(contributorId)
    })
    queueCachesActions.fetchPersonLabels(personId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isNullOrUndefined(personSummary) || contributorsIds.some((contributorId) => isNullOrUndefined(contributorId))) {
    return null
  }

  return (
    <Grid>
      {/* Row */}
      <Cell columns={6}>
        <DataBlock
          heading={t('person.label', 'Person')}
          data={
            <>
              <PersonLink personId={personId} personName={personSummary?.summary?.name} showId newTab />
              <TreePersonLink personId={personId} treeIcon newTab />
            </>
          }
        />
      </Cell>
      <Cell columns={6}>
        <DataBlock heading={t('contributors', 'Contributors')} />
        {contributorsIds.map((contributorId) => {
          return (
            <React.Fragment key={contributorId}>
              <UserLink
                userId={contributorId}
                userName={queueCachesState.usersCache[contributorId]?.contactName}
                showId
                newTab
              />
            </React.Fragment>
          )
        })}
      </Cell>

      <TreeIdCells treeId={messageDetails?.treeId} isResearcherTree={messageDetails?.researcherTree} />

      <LabelsBlock personLabels={personLabels} />
    </Grid>
  )
}
